import React, { FC } from 'react';

import * as styles from './PopoverContent.scss';

const RoleActionLinkText: FC = ({ children }) => (
  <span className={styles.actionText}>{children}</span>
);

export default RoleActionLinkText;
